import { QuestionType } from "../types/questionType";
import { TemplateEnum } from "../types/templateEnum";

export const isWelcomePageBlock = (question: QuestionType) => {
  return question.answerTemplate?.type === TemplateEnum.START_BLOCK && question.startBlock;
};
